import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { ItemEntity } from './item.entity';

@Index('_fk__file__id', ['fkFileId'], {})
@Index('_fk_item__id', ['fkItemId'], {})
@Entity('item__file')
export class ItemFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_item__id', unsigned: true })
	public fkItemId!: number;

	@ManyToOne(() => FileEntity, (file) => file.itemFiles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;

	@ManyToOne(() => ItemEntity, (item) => item.itemFiles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;
}
